// import './NavDropdownButton.css'
// import { __RouterContext as RouterContext, matchPath } from 'react-router';
// import { resolveToLocation, normalizeToLocation } from '../utilities/locationUtilities';
// import { joinClassnames } from '../utilities/renderUtilities';

// function NavDropdownButton({
//     'aria-current': ariaCurrent = 'page',
//     className: classNameProp,
//     activeClassName = 'active',
//     activePath,
//     exact,
//     strict,
//     open,
//     ...rest
// }){

//     return (
//         <RouterContext.Consumer>
//             {context => {
                
//                 const activePathLocation = normalizeToLocation(
//                     resolveToLocation(activePath, context.location),
//                     context.location
//                 );

//                 const { pathname: path } = activePathLocation;

//                 const escapedPath = 
//                     path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
                
//                 const match = escapedPath
//                     ? matchPath(context.location.pathname, {
//                         path: escapedPath,
//                         exact,
//                         strict
//                     })
//                     : null;
                
//                 const isActive = !!(match);
                
//                 const className = joinClassnames('nav-dropdown-btn', isActive
//                     ? joinClassnames(classNameProp, activeClassName)
//                     : classNameProp );

//                 let props = {
//                     'aria-current': (isActive && ariaCurrent) || null,
//                     'aria-expanded': open,
//                     className,
//                     ...rest
//                 }

//                 return <button {...props} />
//             }}
//         </RouterContext.Consumer>
//     );
// }

// export default NavDropdownButton;


import './NavDropdownButton.css';
import { useLocation, matchPath } from 'react-router-dom';
import { resolveToLocation, normalizeToLocation } from '../utilities/locationUtilities';
import { joinClassnames } from '../utilities/renderUtilities';

function NavDropdownButton({
    'aria-current': ariaCurrent = 'page',
    className: classNameProp,
    activeClassName = 'active',
    activePath,
    exact,
    strict,
    open,
    ...rest
}) {
    const location = useLocation();  // Get current route

    if (!activePath) return null; // Ensure activePath is defined

    const activePathLocation = normalizeToLocation(
        resolveToLocation(activePath, location),
        location
    );

    if (!activePathLocation || !activePathLocation.pathname) return null; // Ensure pathname exists

    const { pathname: path } = activePathLocation;

    const escapedPath = path ? path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1') : null;

    const match = escapedPath ? matchPath(escapedPath, location.pathname) : null;  // Updated matchPath usage

    const isActive = !!match;

    const className = joinClassnames(
        'nav-dropdown-btn',
        isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp
    );

    let props = {
        'aria-current': isActive ? ariaCurrent : null,
        'aria-expanded': open,
        className,
        ...rest
    };

    return <button {...props} />;
}

export default NavDropdownButton;
